<template>
  <div class="parent">
    <div class="divTitle" :style="{ color: titleColor }">{{ title }}</div>
    <div class="divSubTitle" :style="{ color: subTitleColor }" v-if="subTitle">{{ subTitle }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "rgba(33,33,33,1)",
    },
    subTitleColor: {
      type: String,
      default: "rgba(109,109,109,1)",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/titleWidge.scss";
</style>
